import { Handle, Position, type NodeProps } from "@xyflow/react";
import { HelpCircle } from "@untitledui/icons";
import type { DecisionCondition } from "@/types/workflow";
import { useTranslation } from "react-i18next";

export const DecisionNode = ({ data }: NodeProps) => {
    const { t } = useTranslation('pages:workflows-admin');
    const label = (data?.label as string) || t('workflows.editor.defaultLabels.decision');
    const condition = data?.condition as DecisionCondition | undefined;
    return (
        <div className="rounded-lg bg-utility-warning-50 border-2 border-utility-warning-500 shadow-md min-w-[150px]">
            <Handle type="target" position={Position.Top} className="w-3 h-3 bg-utility-warning-500" />
            <Handle type="source" position={Position.Bottom} id="yes" className="w-3 h-3 bg-utility-success-500" />
            <Handle type="source" position={Position.Bottom} id="no" className="w-3 h-3 bg-utility-error-500" />
            <Handle type="source" position={Position.Right} id="container" className="w-3 h-3 bg-utility-blue-500" />
            <div className="flex flex-col gap-1 px-3 py-2">
                <div className="flex items-center gap-2">
                    <HelpCircle className="size-4 text-utility-warning-600" />
                    <span className="text-sm font-semibold text-utility-warning-700">{label}</span>
                </div>
                {condition && (
                    <span className="text-xs text-utility-warning-600 opacity-75">
                        {condition.field} {condition.operator}
                    </span>
                )}
            </div>
        </div>
    );
};
